import { normalizeTextFieldValue } from 'utils/prepare-fields';

export const dancerDefaultValuesModel = ({
  id,
  address,
  birthdate,
  first_name,
  last_name,
  full_name,
  email,
  phone,
  photo,
  relationships,
  measurements,
  user,
  notes,
}) => {
  return {
    id,
    user,
    birthdate: birthdate || null,
    first_name: first_name || '',
    last_name: last_name || '',
    full_name: full_name || '',
    email: email || '',
    phone: phone || '',
    measurements,
    relationships,
    avatar: photo || null,
    fullAddress: address.summary,
    city: address.city || '',
    country: { label: 'UK', value: 'UK' },
    state: normalizeTextFieldValue(address.state),
    address_line_1: address.address_line_1 || '',
    address_line_2: address.address_line_2 || '',
    zipcode: address.zipcode || '',
    notes: notes || [],
  };
};
